// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import LookupAttributesRequestViewModel from '../../viewModel/request/Attributes/LookupAttributesRequestViewModel';
import OperatingModeRequestViewModel from '../../viewModel/request/Attributes/OperatingModeRequestViewModel';
import OperationAreaRequestViewModel from '../../viewModel/request/Attributes/OperationAreaRequestViewModel';
import GuidLookupResourcePagingResultViewModel from '../../viewModel/resource/GuidLookupResourcePagingResultViewModel';
import OperatingModeLookupResourcePagingResultViewModel from '../../viewModel/resource/OperatingModeLookupResourcePagingResultViewModel';
import AttributeLookupResourcePagingResultViewModel from '../../viewModel/resource/AttributeLookupResourcePagingResultViewModel';

export default (service: Servicelayer) => ({
  /**  */
  async lookupAttributes(request: LookupAttributesRequestViewModel, config?: RequestConfig) {
    const requestDTO = request.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-lookup-attributes'] ?? 'Attributes';
    const response = await service.get<any>(endpointPath, {
      query: {
        id: requestDTO.id,
        key: requestDTO.key,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return new GuidLookupResourcePagingResultViewModel().fromDTO(dto);
  },
  /**  */
  async operatingMode(request: OperatingModeRequestViewModel, config?: RequestConfig) {
    const requestDTO = request.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-operating-mode'] ?? 'Attributes/OperatingMode';
    const response = await service.get<any>(endpointPath, {
      query: {
        id: requestDTO.id,
        key: requestDTO.key,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return new OperatingModeLookupResourcePagingResultViewModel().fromDTO(dto);
  },
  /**  */
  async operationArea(request: OperationAreaRequestViewModel, config?: RequestConfig) {
    const requestDTO = request.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-operation-area'] ?? 'Attributes/OperationArea';
    const response = await service.get<any>(endpointPath, {
      query: {
        id: requestDTO.id,
        key: requestDTO.key,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return new AttributeLookupResourcePagingResultViewModel().fromDTO(dto);
  },
});
